import React, { useState, useRef } from "react";
import LoginForm from "./LoginForm";
import setAuthorization from "../utilities/setAuthorization";
import makeRequest from "../utilities/makeRequest";

const LoginContainer = ({
  closeModalAfterAuthentication,
  errors,
  login,
  setErrors,
}) => {
  const form = useRef();
  const checkButton = useRef();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const onChangeEmail = (event) => {
    setEmail(event.target.value);
  };

  const onChangePassword = (event) => {
    setPassword(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    form.current.validateAll();

    if (checkButton.current.context._errors.length === 0) {
      const url = `${process.env.REACT_APP_HOST}/api/v1/users/login`;
      const verb = "POST";
      const headers = new Headers({ "Content-Type": "application/json" });

      const body = JSON.stringify({
        user: {
          email: email,
          password: password,
        },
      });

      makeRequest(url, verb, body, headers)
        .then((response) => {
          setAuthorization(
            closeModalAfterAuthentication,
            login,
            response,
            setErrors,
            "login"
          );
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  return (
    <LoginForm
      checkButton={checkButton}
      closeModal={closeModalAfterAuthentication}
      email={email}
      errors={errors}
      form={form}
      handleSubmit={handleSubmit}
      onChangeEmail={onChangeEmail}
      onChangePassword={onChangePassword}
      password={password}
      setErrors={setErrors}
    />
  );
};

export default LoginContainer;
